import { partition } from 'lodash';
import { useContext, useEffect, useState } from 'react';

import SkillApi from '../../api/skillApi';
import Page from '../../components/page-layout/Page';
import SkillService from '../../services/skillService';
import SkillData from '../../types/skillData';
import { AuthContext } from '../../utils/AuthProvider';
import ModalContext from '../../utils/ModalContext';
import SkillCardRow from '../dashboard/SkillCardRow';
import SkillCardRowWithAdd from '../dashboard/SkillCardRowWithAdd';

import './MyCreations.scss';

export default function MyCreations() {
  const [allSkills, setAllSkills] = useState<SkillData[]>([]);
  const { user } = useContext(AuthContext)!;
  const [mySkills, otherSkills] = partition(allSkills, skill => skill.authorUuid === user?.uid);
  const [myPublishedSkills, myUnpublishedSkills] = partition(mySkills, skill => skill.isPublished);
  const [otherPublishedSkills, otherUnpublishedSkills] = partition(otherSkills, skill => skill.isPublished);
  const { showDeleteSkillModal } = useContext(ModalContext);

  useEffect(() => {
    async function fetchData() {
      if (user) {
        const fetchedSkills = await SkillApi.getSkills();
        setAllSkills(fetchedSkills);
      }
    }

    fetchData();
  }, [user]);

  async function handleDelete(skill: SkillData) {
    showDeleteSkillModal(skill, async () => {
      const updatedSkills = await SkillService.removeSkillFromArray(skill, allSkills);
      setAllSkills(updatedSkills);
    });
  }

  async function handleTogglePublish(skill: SkillData) {
    const updatedSkills = await SkillService.toggleSkillIsPublishedFromArray(skill, allSkills);
    setAllSkills(updatedSkills);
  }

  return (
    <Page
      className="my-creations"
      activeNavlink="my-creations"
      breadcrumbs={[
        ['/', 'Home'],
        ['/my-creations', 'Create'],
      ]}
    >
      <SkillCardRowWithAdd
        className="mb-16"
        skills={myPublishedSkills}
        headline="My published skills"
        cardSize="xs"
        admin
        onDelete={handleDelete}
        onTogglePublish={handleTogglePublish}
      />
      <SkillCardRow
        className="mb-16"
        skills={myUnpublishedSkills}
        headline="My unpublished skills"
        cardSize="xs"
        admin
        onDelete={handleDelete}
        onTogglePublish={handleTogglePublish}
      />
      <SkillCardRow
        className="mb-16"
        skills={otherPublishedSkills}
        headline="Other published skills"
        cardSize="xs"
        admin
        onDelete={handleDelete}
        onTogglePublish={handleTogglePublish}
      />
      <SkillCardRow
        className="mb-16"
        skills={otherUnpublishedSkills}
        headline="Other unpublished skills"
        cardSize="xs"
        admin
        onDelete={handleDelete}
        onTogglePublish={handleTogglePublish}
      />
    </Page>
  );
}
